import Vue from 'vue';
export const EventBus = new Vue();

//USAGE
//import { EventBus } from '../event-bus'
//EventBus.$on('tree-item-selected', this.treeItemSelected);
////this.$emit('tree-item-selected', 'someData');
//EventBus.$emit('tree-item-selected', this.model)

//new method events: {